import { useContext } from "react";
import { ThemeContext } from "./theme-provider";
import type { Density } from "./theme-provider";

/** Access the active theme and theme controls. */
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme must be used within a <ThemeProvider>.");
  }
  return ctx;
}

/** Access the active density (comfortable/compact) and its setter. */
export function useDensity(): {
  density: Density;
  setDensity: (d: Density) => void;
} {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useDensity must be used within a <ThemeProvider>.");
  }
  return { density: ctx.density, setDensity: ctx.setDensity };
}
